import * as React from 'react';
import type { SVGProps } from 'react';
const SvgXTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={16} fill='currentColor' {...props}>
    <path d='M13.5.017h2.631L10.39 6.548l6.754 8.897h-5.289l-4.148-5.4-4.74 5.4H.343l6.146-6.994L0 .017h5.426L9.17 4.945zM12.437 13.73h1.457l-9.145-12H3.17l9.258 12z' />
  </svg>
);
export default SvgXTwitter;
